import { useTheme } from '@mui/material/styles';
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { DateRange as ECDateRange } from '@eatclubcode/ec-component-library';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import dayjs from 'dayjs';
import { setDateRangeAction, setDatesAction } from '../../actions/datePickerAction';
import { devLog, useQuery } from '../../utils';
import { isEmpty } from '../../utils/baseHelpers';
import { defaultDateRangeOptions } from '../../utils/insights/insightHelpers';

// TODO this is overkill for its one use. Refactor customer value to just use a dropdown instead
const DatePicker = ({
  dates = {},
  dateRangeInput = null,
  setDateRange = () => {},
  setDates = () => {},
  onDateRangeChange,
}) => {
  const theme = useTheme();
  const query = useQuery();

  const startDate = query.get('startDate');
  const endDate = query.get('endDate');

  // Automatically set the date if it's set in the URL
  useEffect(() => {
    if (!isEmpty(startDate) || !isEmpty(endDate)) {
      const newStartDate = startDate ?? dates?.startDate;
      const newEndDate = endDate ?? dates?.endDate;

      setDates(dayjs(newStartDate), dayjs(newEndDate));
    }
  }, [startDate, endDate]);

  const dateRangesToUse = useMemo(() => {
    return dateRangeInput ?? defaultDateRangeOptions;
  }, [dateRangeInput, defaultDateRangeOptions]);

  // Get the dates to show in the calendar
  const dayJsDates = useMemo(() => {
    // If date range is all time, don't make the calendar go all the way back like that
    if (dates.value !== null) {
      return {
        ...dates,
        startDate: dates?.endDate.subtract(1, 'month'),
        endDate: dates?.endDate,
      };
    }

    return {
      ...dates,
      startDate: dates?.startDate,
      endDate: dates?.endDate,
    };
  }, [dates.value, dates?.startDate, dates?.endDate]);

  const handleDayUpdate = (newFilters) => {
    const wasChanged =
      !dates?.startDate.isSame(newFilters?.startDate, 'day') ||
      !dates?.endDate.isSame(newFilters?.endDate, 'day');

    if (wasChanged) {
      devLog('info', 'updating dates', newFilters);
      setDates(dayjs(newFilters?.startDate), dayjs(newFilters?.endDate));
      // setDatesDayjs(newFilters?.startDate, newFilters?.endDate, newFilters?.dateRange);
    }
  };

  if (isEmpty(dayJsDates)) {
    return <></>;
  }

  return (
    <>
      <ECDateRange
        filters={dayJsDates}
        setFilters={handleDayUpdate}
        dateRangeOptions={dateRangesToUse}
        setDateRange={(dateRange) => {
          onDateRangeChange(dateRange);
          setDateRange(dateRange);
        }}
        style={{
          dropdown: {
            dropdown: {
              backgroundColor: theme.colors.pageBackground,
            },
            menu: {
              maxHeight: '700px',
            },
          },
        }}
      />
    </>
  );
};

DatePicker.propTypes = {
  dates: PropTypes.shape({}),
  setDateRange: PropTypes.func,
  setDates: PropTypes.func,
};

const mapStateToProps = (state) => ({
  dates: state.dates,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setDateRange: setDateRangeAction,
      setDates: setDatesAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(DatePicker);
